"use client";

import React from "react";
import RichText from "../RichText";

export default function ContentBlock({ content }: { content: any }) {
  if (!content) return null;
  return (
    <section className="block-content" style={{ marginBottom: "2rem" }}>
      <RichText content={content} />
    </section>
  );
}
